import { render, staticRenderFns } from "./RecordNextContact.vue?vue&type=template&id=2b989150&scoped=true&"
import script from "./RecordNextContact.vue?vue&type=script&lang=js&"
export * from "./RecordNextContact.vue?vue&type=script&lang=js&"
import style0 from "./RecordNextContact.vue?vue&type=style&index=0&id=2b989150&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b989150",
  null
  
)

export default component.exports